// extracted by mini-css-extract-plugin
module.exports = {"paraContainer":"_3SQIxFmjiD6QvJ94HiikN9","iosCardContainer":"_2wZ_ClmKtVgoLphzRzhuwH","cardContainer":"_1MRB861NDl5JJznqsmoRsR","btnContainer":"_2UkImy3LJoJ9jIbFUKBG4b"};